// src/util/propTypes.ts
import PropTypes from "prop-types";
var getScalarPropType = function getScalarPropType() {
  return PropTypes.oneOfType([PropTypes.number, PropTypes.string]);
};
var getArrayOfScalarPropType = function getArrayOfScalarPropType() {
  return PropTypes.arrayOf(getScalarPropType().isRequired);
};
export { getScalarPropType, getArrayOfScalarPropType };